var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9979 29.9958C23.281 29.9958 29.9958 23.281 29.9958 14.9979C29.9958 6.71478 23.281 0 14.9979 0C6.71478 0 0 6.71478 0 14.9979C0 23.281 6.71478 29.9958 14.9979 29.9958Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8623 13.3301L21.6522 6.62061",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5989 8.88084C16.4405 8.88084 17.1228 8.19856 17.1228 7.35692C17.1228 6.51529 16.4405 5.83301 15.5989 5.83301C14.7572 5.83301 14.075 6.51529 14.075 7.35692C14.075 8.19856 14.7572 8.88084 15.5989 8.88084Z",
    stroke: "white",
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9071 14.1212C21.7494 14.1212 22.4352 13.4355 22.4352 12.5931C22.4352 11.7507 21.7494 11.0649 20.9071 11.0649C20.0647 11.0649 19.3789 11.7507 19.3789 12.5931C19.3789 13.4355 20.0647 14.1212 20.9071 14.1212Z",
    stroke: "white",
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26172 14.583H8.05133C8.64397 14.583 9.12654 15.0656 9.12654 15.6582V23.1296H5.26172V14.583Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12646 16.2129L12.6145 15.1123L18.5959 18.2279C20.268 19.0999 19.0277 21.5128 17.3387 20.6323L13.7786 18.7739L12.8177 19.3793",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9008 20.5011L23.4344 18.4523C25.4155 17.5591 26.4611 20.2598 24.6112 21.0853L18.8585 23.659C16.962 24.5818 14.9894 24.7427 13.5036 23.968L9.12231 21.6779",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscounts);
export default __webpack_public_path__ + "static/media/discounts.f0891182915591444a0c44794c3814d3.svg";
export { ForwardRef as ReactComponent };